import type { ContactCardSectionGhostDenseProps } from "@costar-ui/info-cards";
import type { ContactCardData } from "@costar-ui/share-compositions";

import { Resources } from "$i18n";

function getContactCardInfo(
    resources: Resources,
    data?: ContactCardData,
    isLoading?: boolean
): ContactCardSectionGhostDenseProps {
    const { photoUrl, contactName, phoneNumber, extension } = data || {};
    return {
        photo: {
            src: photoUrl,
        },
        name: {
            label: contactName,
        },
        jobTitle: {
            label: resources.requestTraining.jobTitle(),
        },
        phone: {
            labels: {},
            numbers: {
                office:
                    extension && phoneNumber
                        ? resources.requestTraining.phoneNumberExt({ phoneNumber, extension })
                        : phoneNumber,
            },
        },
        isLoading,
    };
}

export default getContactCardInfo;
